import { KeyValueDTO } from "./keyvalue.model";
import { PackageDTO } from "./package.model";
import { SpecialPrice } from "./specialprice.model";
import { VariantValuesDTO } from "./variant.model";

export class SubVariants {
    type: string;
    subType: string;
    value: VariantValuesDTO;

    constructor(
        type: string = "",
        subType: string = "",
        value: VariantValuesDTO = new VariantValuesDTO(),
    ) {
        this.type = type;
        this.subType = subType;
        this.value = value;
    }
}

export class SubProduct {
    price: number;
    variants: SubVariants[];
    specialPrice: SpecialPrice;
    stock: number;
    freeItems: string;
    isAvailable: boolean;
    extraFields: KeyValueDTO[];
    productPackage: PackageDTO;
    sold: number;
    sellerSku: string;
    sku: string;
    referenceId: string = "";
    // for frontend
    id: string;
    secondaryId: string;
    extra: any = {};


    constructor(
        productPackage: PackageDTO = new PackageDTO(),
        id: string = "default",
        secondaryId: string = "default",
        variants: SubVariants[] = [],
        price: number = 0,
        specialPrice: SpecialPrice = new SpecialPrice(),
        stock: number = 0,
        freeItems: string = "",
        isAvailable: boolean = true,
        extraFields: KeyValueDTO[] = [],
        sold: number = 0,
        sellerSku: string = "",
        sku: string = "",
    ) {
        this.id = id;
        this.secondaryId = secondaryId;
        this.price = price;
        this.variants = variants;
        this.specialPrice = specialPrice;
        this.stock = stock;
        this.freeItems = freeItems;
        this.isAvailable = isAvailable;
        this.extraFields = extraFields;
        this.productPackage = productPackage;
        this.sold = sold;
        this.sellerSku = sellerSku;
        this.sku = sku;
    }

    public static copy(destination: SubProduct, source: SubProduct) : SubProduct {
        destination = source;
        if (destination.price != source.price) destination.price = source.price;
        if (destination.stock != source.stock) destination.stock = source.stock;
        if (destination.freeItems != source.freeItems) destination.freeItems = source.freeItems;
        if (destination.isAvailable != source.isAvailable) destination.isAvailable = source.isAvailable;
        if (destination.sold != source.sold) destination.sold = source.sold;
        if (destination.sellerSku != source.sellerSku) destination.sellerSku = source.sellerSku;
        if (destination.sku != source.sku) destination.sku = source.sku;
        if (source.productPackage) {
            destination.productPackage = PackageDTO.copy(destination.productPackage, source.productPackage);
        }
        if (source.specialPrice) {
            destination.specialPrice = SpecialPrice.copy(destination.specialPrice, source.specialPrice);
        }

        destination.extraFields = [];
        for (let extraField of source.extraFields) {
            let obj = new KeyValueDTO();
            obj = Object.assign(obj, extraField);
            destination.extraFields.push(obj);
        }
        return destination;
    }
}